/**
 * 入金情報
 */
export class PaymentInfo {
    /** 入金日 */
    paymentOn: string | null = null
    /** 入金金額 */
    depositAmount = 0
    /** 入金入力日時 */
    paymentAt: string | null = null
    /** 入金入力ユーザーID*/
    paymentUserId: string | null = null
    /** 削入金入力ユーザー名 */
    paymentUserName = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<PaymentInfo>) {
        Object.assign(this, init)
    }
}
